import { Controller } from "@hotwired/stimulus"

// Tracks parley progress on the show page. Counts assistant message bubbles
// in the shared transcript (#messages) and updates a counter target each
// time a new one arrives. When the cap is reached it swaps the "Start with"
// controls / "In progress" pill for a "Complete" banner.
export default class extends Controller {
  static targets = ["counter", "completeBanner", "startControls", "inProgress"]
  static values = { max: Number, transcriptSelector: { type: String, default: "#messages" } }

  connect() {
    this._update = this.update.bind(this)
    this.update()
    const messagesEl = document.querySelector(this.transcriptSelectorValue)
    if (messagesEl) {
      this.observer = new MutationObserver(this._update)
      this.observer.observe(messagesEl, { childList: true, subtree: true })
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  update() {
    const transcript = document.querySelector(this.transcriptSelectorValue)
    if (!transcript) return
    const count = transcript.querySelectorAll('[data-message-role="assistant"]').length
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${count} / ${this.maxValue}`
    }

    if (count >= this.maxValue) {
      this.completeBannerTarget?.classList.remove("hidden")
      this.startControlsTarget?.classList.add("hidden")
      this.inProgressTarget?.classList.add("hidden")
    } else if (count > 0) {
      this.startControlsTarget?.classList.add("hidden")
      this.inProgressTarget?.classList.remove("hidden")
    }
  }
}
